shadow$provide[194] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Camera:{enumerable:true, get:function() {
  return Camera;
}}});
var UThree = require("../../../util/three.js");
var require$three = require("three");
var require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js = require("../../primitive.js");
class Camera extends require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive {
  static initClass() {
    this.traits = ["node", "camera"];
  }
  init() {
  }
  make() {
    const camera = this._context.defaultCamera;
    this.camera = this.props.proxy ? camera : camera.clone();
    this.euler = new require$three.Euler();
    return this.quat = new require$three.Quaternion();
  }
  unmake() {
  }
  getCamera() {
    return this.camera;
  }
  change(changed, touched, init) {
    if (changed["camera.position"] || changed["camera.quaternion"] || changed["camera.rotation"] || changed["camera.lookAt"] || changed["camera.up"] || changed["camera.fov"] || init) {
      const {position, quaternion, rotation, lookAt, up, fov} = this.props;
      if (position != null) {
        this.camera.position.copy(position);
      }
      if (quaternion != null || rotation != null || lookAt != null) {
        if (lookAt != null) {
          this.camera.lookAt(lookAt);
        } else {
          this.camera.quaternion.set(0, 0, 0, 1);
        }
        if (rotation != null) {
          this.euler.setFromVector3(rotation, UThree.swizzleToEulerOrder(this.props.eulerOrder));
          this.quat.setFromEuler(this.euler);
          this.camera.quaternion.multiply(this.quat);
        }
        if (quaternion != null) {
          this.camera.quaternion.multiply(quaternion);
        }
      }
      if (fov != null && this.camera.fov != null) {
        this.camera.fov = fov;
      }
      if (up != null) {
        this.camera.up.copy(up);
      }
      return this.camera.updateMatrix();
    }
  }
}
Camera.initClass();

};